import InfiniteScroll from "react-infinite-scroll-component";
import { SearchContainer } from "../components/search-container";
import { Loader } from "../components/loader";
import { useCallback, useEffect, useRef, useState } from "react";
import { BASE_URL, CATEGORY_NAME_MAP, ROUTES } from "../assets/constant";
import "./favourite.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { convertInMonthNameFormat } from "../utils/helper";
import { highlightText } from "./../utils/helper";

export const Favourite = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    data: [],
    total: 0
  });

  const user = useSelector((state) => state.auth);
  const [searchQuery, setSearchQuery] = useState("");
  const page = useRef(1);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${BASE_URL}/v2.0/get-favourites`,
        {
          user_id: user.user.id,
          params: {
            page: page.current,
            searchQuery: searchQuery
          }
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );
      setData((prevData) => ({
        data:
          page.current !== 1
            ? [...prevData.data, ...(response?.data?.data ?? [])]
            : response?.data?.data ?? [],
        total: response?.data?.total
      }));
      page.current += 1;
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [searchQuery, user.token, user.user.id]);

  const handleFavourite = async (item) => {
    try {
      await axios.delete(`${BASE_URL}/v1.0/remove-favourites`, {
        data: {
          user_id: user.user.id,
          recall_id: item.recall_id,
          category_id: item.category_id
        },
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      });

      setData((prevData) => ({
        ...prevData,
        data: prevData.data.filter((d) => d.recall_id !== item.recall_id)
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setData({ data: [], total: 0 });
    page.current = 1;
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="subscriber-container">
      <SearchContainer title="Favourite" handleSearch={handleSearch} />
      <div className="favourite-recalls">
        <h4 style={{ padding: "0 10px" }}>Favourite Recalls</h4>
        <InfiniteScroll
          dataLength={data.total}
          next={fetchData}
          hasMore={data.data.length < data.total}
          loader={<Loader />}>
          <div className="favourite-recall-list">
            {data?.data?.map((d) => (
              <FavouriteCard
                key={d?.id}
                item={d}
                handleFavourite={handleFavourite}
                query={searchQuery}
              />
            ))}
          </div>

          {data?.data?.length === 0 && !isLoading && (
            <div className="text-center mt-5">
              <h5>No Data Found</h5>
            </div>
          )}
          {isLoading && (
            <div className="text-center mt-5">
              <Loader />
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

const FavouriteCard = ({ item, handleFavourite, query }) => {
  const route = ROUTES.RECALL_DETAILS.replace(
    ":type",
    CATEGORY_NAME_MAP[item?.category_id]
  ).replace(":id", item?.recall_id);
  return (
    <div className="recalllistcard">
      <Link
        to={`${ROUTES.FAVOURITE}/${route}`}
        style={{ textDecoration: "none" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontWeight: "600", color: "black", fontSize: "14px" }}>
            {highlightText(item?.RecallTitle || item?.recall_title, query)}
          </span>
          <span
            style={{ flex: "0 0 auto", marginLeft: "10px", fontSize: "12px" }}>
            {convertInMonthNameFormat(
              item?.recall_date || item?.RecallDate || item?.Date || ""
            )}
          </span>
        </div>
        <div className="row">
          <h3 className="card-summary">
            {highlightText(
              item?.description || item?.recall_desc || item?.impact,
              query
            )}
          </h3>
        </div>
      </Link>

      <div className="row">
        <button
          className="favorite-button"
          onClick={() => handleFavourite(item)}>
          <i className="fa fa-star"></i> Remove as favourite
        </button>
      </div>
    </div>
  );
};
FavouriteCard.propTypes = {
  item: PropTypes.object.isRequired,
  handleFavourite: PropTypes.func.isRequired
};
